<template>

	<div class="custom-textarea" contenteditable="true" @input="updateHTML">
		Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
		tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
		quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
		consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
		cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
		proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
	</div>

</template>


<script>

    export default {
     	name: "html-textarea",
        props:['value'],

        data(){
		    return{
		    	
		    }
		},

		mounted(){
		    this.$el.innerHTML = this.value;
		},

		methods: {
		    updateHTML: function(e) {
		      this.$emit('input', e.target.innerHTML);
		    }
		}

    }

</script>

